/*eslint-disable no-extend-native */
// Polyfill for String.prototype.replaceAll
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    return this.split(search).join(replacement);
  };
}
